module.exports = __webpack_public_path__ + "img/documentorder_example.060072e7.png";